import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import makeRequest from "services/makeRequest";
import { routes } from "routes/apiRoutes";
import { Loader, Typography } from "components";
import { setNOKDetails } from "redux/actions/onboardingActions";

import {
  isSuccessResponse,
  notFoundStatus,
  capitalizeFirstLetter,
  getGender,
} from "utils/helper";

const NOKInfo = ({ agentId }) => {
  const [loading, setLoading] = useState(false);
  const [displayNoInfo, setDisplayNoInfo] = useState(false);

  const { NOKDetails } = useSelector((state) => state.onBoardingInfo);

  const {
    phoneNumber,
    email,
    firstName,
    gender,
    lastName,
    address,
    region,
    state,
    relationship,
  } = NOKDetails || {};

  const renderDetails = [
    { label: "First Name", value: capitalizeFirstLetter(firstName) },
    { label: "Last Name", value: capitalizeFirstLetter(lastName) },
    { label: "Gender", value: getGender(gender)?.label },
    // { label: "Date Of Birth", value: formatDateTime(dateOfBirth) },
    { label: "Phone Number", value: phoneNumber },
    { label: "Email", value: email },
    { label: "Address", value: address },
    { label: "State", value: state },
    { label: "Region", value: region },
    { label: "Relationship of Agent to next of kin", value: relationship },
  ];

  useEffect(() => {
    const getAgentNOKDetails = async () => {
      setLoading(true);
      try {
        const { data } = await makeRequest(
          "get",
          routes.nextOfKinInfo(agentId)
        );

        if (isSuccessResponse(data)) {
          const NOKDetail = {
            ...data.data,
          };
          setNOKDetails(NOKDetail);
        }

        if (notFoundStatus(data)) {
          setDisplayNoInfo(true);
        }
        setLoading(false);
      } catch (error) {}
    };
    !NOKDetails && getAgentNOKDetails();
  }, [agentId, NOKDetails]);

  if (loading)
    return (
      <div className="d-flex justify-content-center onboarding-loader">
        <Loader />
      </div>
    );

  if (displayNoInfo)
    return (
      <Typography variant="subtitle3" className={"text-center mt-3"}>
        No Next of Kin Information provided
      </Typography>
    );

  return (
    <div className="row user-detail-container">
      {renderDetails.map(({ label, value }, key) => (
        <div className="col-md-6 mt-3" key={key}>
          <Typography>
            {label}: &nbsp; &nbsp; {value}
          </Typography>
        </div>
      ))}
    </div>
  );
};

export default NOKInfo;
